// Login form.
import React from 'react';
import { FormattedMessage } from 'react-intl';

import CheckBox from '../widgets/checkbox.jsx';
import VisiblePassword from '../widgets/visible-password.jsx';

export default class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login: props.login,
      password: '',
      hostName: props.serverAddress,
      saveToken: props.persist
    };
    this.handleLoginChange = this.handleLoginChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleToggleSaveToken = this.handleToggleSaveToken.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleLoginChange(e) {
    this.setState({login: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleToggleSaveToken() {
    this.props.onPersistenceChange(!this.state.saveToken);
    this.setState({saveToken: !this.state.saveToken});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onLogin(this.state.login.trim(), this.state.password.trim());
  }

  render() {
    let submitClasses = 'qq-primary-button';
    if (this.props.disabled) {
      submitClasses += ' disabled';
    }

    return (
      <div className="qq-auth-card">
        <div className="qq-auth-brand">
          <img src="img/logo.svg" alt="" />
          <div>
            <h1>Tinode</h1>
            <p>简洁、轻盈的即时通讯</p>
          </div>
        </div>
        <h2 className="qq-auth-title">
          <FormattedMessage id="login_prompt" defaultMessage="Login"
            description="Placeholer for username/login" />
        </h2>
        <form id="login-form" onSubmit={this.handleSubmit}>
          <label className="qq-field">
            <span className="qq-field-label">账号</span>
            <FormattedMessage id="login_prompt" defaultMessage="Login"
              description="Placeholer for username/login">
            {
              (login_prompt) => <input type="text" id="inputLogin"
                placeholder={login_prompt}
                autoComplete="username"
                autoCorrect="off"
                autoCapitalize="none"
                value={this.state.login}
                onChange={this.handleLoginChange}
                required autoFocus />
            }
            </FormattedMessage>
          </label>
          <label className="qq-field">
            <span className="qq-field-label">密码</span>
            <FormattedMessage id="password_prompt" defaultMessage="Password"
              description="Placeholder/prompt for entering password">
            {
              (password_prompt) => <VisiblePassword type="password" id="inputPassword"
                placeholder={password_prompt}
                autoComplete="current-password"
                value={this.state.password}
                onChange={this.handlePasswordChange}
                required={true} />
            }
            </FormattedMessage>
          </label>
          <div className="qq-auth-row">
            <label className="qq-checkbox-label">
              <CheckBox id="save-token" name="save-token" checked={this.state.saveToken}
                onChange={this.handleToggleSaveToken} />
              <span>
                <FormattedMessage id="stay_logged_in" defaultMessage="Stay logged in"
                  description="Label for a checkbox" />
              </span>
            </label>
            <a href="#reset" className="qq-text-link">
              <FormattedMessage id="forgot_password_link" defaultMessage="Forgot password?"
                description="Link to Reset password form" />
            </a>
          </div>
          <button className={submitClasses} type="submit" disabled={this.props.disabled}>
            <FormattedMessage id="button_sign_in" defaultMessage="Sign in"
              description="Button [Sign In]" />
          </button>
          <div className="qq-auth-links">
            {this.props.onSignUp ?
              <a href="#register" className="qq-text-link"
                onClick={e => {e.preventDefault(); this.props.onSignUp();}}>
                创建账号
              </a> : null}
            {this.props.onSettings ?
              <a href="#settings" className="qq-text-link"
                onClick={e => {e.preventDefault(); this.props.onSettings();}}>
                服务器设置
              </a> : null}
          </div>
        </form>
      </div>
    );
  }
};
